import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { SubMenu as RcSubMenu } from 'rc-menu';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'rc-util/lib/omit';
import MenuContext from './config-provider/MenuContext';
import { isValidElement } from './_util/reactNode';

var SubMenu = /*#__PURE__*/function (_React$Component) {
  _inherits(SubMenu, _React$Component);

  var _super = _createSuper(SubMenu);

  function SubMenu() {
    _classCallCheck(this, SubMenu);

    return _super.apply(this, arguments);
  }

  _createClass(SubMenu, [{
    key: "renderTitle",
    value: function renderTitle(inlineCollapsed) {
      var _this$props = this.props,
          icon = _this$props.icon,
          title = _this$props.title,
          level = _this$props.level,
          rootPrefixCls = _this$props.rootPrefixCls;

      if (!icon) {
        return inlineCollapsed && level === 1 && title && typeof title === 'string' ? /*#__PURE__*/React.createElement("div", {
          className: "".concat(rootPrefixCls, "-inline-collapsed-noicon")
        }, title.charAt(0)) : title;
      } // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span


      var titleIsSpan = isValidElement(title) && title.type === 'span';
      return /*#__PURE__*/React.createElement(React.Fragment, null, icon, titleIsSpan ? title : /*#__PURE__*/React.createElement("span", null, title));
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props2 = this.props,
          rootPrefixCls = _this$props2.rootPrefixCls,
          popupClassName = _this$props2.popupClassName,
          popupOffset = _this$props2.popupOffset;
      return /*#__PURE__*/React.createElement(MenuContext.Consumer, null, function (_ref) {
        var inlineCollapsed = _ref.inlineCollapsed,
            menuTheme = _ref.menuTheme;
        return /*#__PURE__*/React.createElement(RcSubMenu, _extends({}, omit(_this.props, ['icon']), {
          title: _this.renderTitle(inlineCollapsed),
          popupOffset: popupOffset,
          popupClassName: classNames(rootPrefixCls, "".concat(rootPrefixCls, "-").concat(menuTheme), popupClassName)
        }));
      });
    }
  }]);

  return SubMenu;
}(React.Component);

_defineProperty(SubMenu, "propTypes", _defineProperty({
  rootPrefixCls: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  level: PropTypes.number,
  title: PropTypes.node,
  icon: PropTypes.node,
  style: PropTypes.object,
  onTitleClick: PropTypes.func,
  onTitleMouseEnter: PropTypes.func,
  onTitleMouseLeave: PropTypes.func,
  popupOffset: PropTypes.array,
  popupClassName: PropTypes.string
}, "popupOffset", PropTypes.array));

_defineProperty(SubMenu, "defaultProps", {
  disabled: false,
  // 是否禁用
  icon: null,
  // 菜单图标
  // popupClassName: '', // 子菜单样式，mode="inline" 时无效
  // title: '', // 子菜单项值
  popupOffset: [0, 5] // 子菜单偏移量，mode="inline" 时无效
  // onTitleClick: null, // 点击子菜单标题

});

_defineProperty(SubMenu, "contextType", MenuContext);

_defineProperty(SubMenu, "isSubMenu", 1);

export default SubMenu;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-menu/src/SubMenu.js